'use client';

/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import { useTranslation } from 'react-i18next';
import type { LearningCourseDetail } from '@akademi/site-builder-runtime';
import { LevelBadge } from '../../_shared/LevelBadge';

interface CourseTitleBlockProps {
  course: LearningCourseDetail;
}

export function CourseTitleBlock({ course }: CourseTitleBlockProps) {
  const { t } = useTranslation('site-builder-blocks');
  const badges: { label: string; variant: 'default' | 'brand' | 'success' | 'amber' }[] = [];

  // Format ALWAYS renders — it's a navigation hint. (Level is the themed
  // LevelBadge below.)
  if (course.format) badges.push({ label: course.format, variant: 'default' });
  if (course.hasCertificate)
    badges.push({ label: t('courseDetail.badge.certified'), variant: 'success' });
  if (course.isBestseller)
    badges.push({ label: t('courseDetail.badge.bestseller'), variant: 'amber' });
  if (course.isHot) badges.push({ label: t('courseDetail.badge.hot'), variant: 'amber' });

  return (
    <div className="cd-title-block">
      <div className="cd-badges">
        <LevelBadge level={course.level} />
        {badges.map((b, i) => (
          <span
            key={i}
            className={`cd-badge${b.variant !== 'default' ? ` cd-badge-${b.variant}` : ''}`}
          >
            {b.label}
          </span>
        ))}
      </div>
      <h1 className="cd-title">{course.title}</h1>
      {course.tagline && <p className="cd-tagline">{course.tagline}</p>}
    </div>
  );
}
